import { useRef } from "react";
import { motion, useScroll } from "framer-motion";
import { SectionHead } from "./SectionHead";
import { Reveal } from "./Reveal";
import { PROTOCOL } from "./data";

const Step = ({ s, i }) => (
  <Reveal delay={0.05} className="relative pl-16 sm:pl-24 pb-16 last:pb-0">
    <span className="absolute left-0 top-1 grid place-items-center w-11 h-11 sm:w-14 sm:h-14 rounded-full bg-[#FCFBF7] border border-[#1B3B28]/15 f-mono text-xs text-[#1B3B28] z-10">
      {s.n}
    </span>
    <div className="group" data-testid={`protocol-step-${i + 1}`}>
      <p className="eyebrow text-[#C86D51]">{s.time}</p>
      <h3 className="f-serif text-3xl sm:text-4xl text-[#1B3B28] mt-3 transition-transform duration-500 group-hover:translate-x-2">{s.title}</h3>
      <p className="text-[#526356] mt-4 max-w-xl leading-relaxed">{s.text}</p>
    </div>
  </Reveal>
);

export const Protocol = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start 70%", "end 60%"] });
  return (
    <section id="protocollo" className="relative py-28 sm:py-40 bg-[#FCFBF7]" data-testid="protocol-section">
      <div className="mx-auto max-w-[1400px] px-6 sm:px-10 grid lg:grid-cols-12 gap-16">
        <div className="lg:col-span-5">
          <div className="lg:sticky lg:top-32">
            <SectionHead
              eyebrow="Il protocollo, passo dopo passo"
              lines={["Cinque tappe.", "Nessuna", "sorpresa."]}
              intro="Ogni percorso è personalizzato, ma la strada è chiara fin dal primo giorno. Saprai sempre cosa succede, quando e perché."
            />
          </div>
        </div>
        <div ref={ref} className="lg:col-span-6 lg:col-start-7 relative">
          <div className="absolute left-[21px] sm:left-[27px] top-2 bottom-2 w-px bg-[#1B3B28]/10" />
          <motion.div style={{ scaleY: scrollYProgress }} className="absolute left-[21px] sm:left-[27px] top-2 bottom-2 w-px bg-[#3E6B48] origin-top" />
          {PROTOCOL.map((s, i) => <Step key={s.n} s={s} i={i} />)}
        </div>
      </div>
    </section>
  );
};
